module.exports = __webpack_public_path__ + "images/1fb1af6.png";